import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, TextField } from "@mui/material";
import { s3baseUrl } from "src/config/config";
import ReactVideoPlayer from "src/components/ReactVideoPlayer/ReactVideoPlayer";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    backgroundColor: "white",
  },
}));

export default function ModalToShowAninfo({ open, setOpen, exercise }) {
  const classes = useStyles();
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        scroll="body"
        maxWidth="md"
        BackdropProps={{
          classes: {
            root: classes.backdrop,
          },
        }}
        PaperProps={{
          style: {
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
          },
        }}
      >
        <div
          className={`text-end mt-1 d-flex justify-content-end align-items-center`}
        >
          <IconButton
            className="back-screen-button me-1 "
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {console.log(exercise, "fjhsdkjfjkas")}
            {exercise?.exercise_type == "something_else" ? (
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                placeholder="Description"
                label="Description"
                type="number"
                value={exercise.description}
                name="description"
                multiline
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  borderRadius: "5px",
                  my: 2,
                  width: "100%",
                }}
              />
            ) : exercise?.exercise_info?._id?.video_url ? (
              <ReactVideoPlayer url={exercise?.exercise_info?._id?.video_url} />
            ) : exercise?.exercise_info?._id?.gif_url ? (
              <div className="w-100 d-flex justify-content-center">
                <img src={s3baseUrl + exercise?.exercise_info?._id?.gif_url} />
              </div>
            ) : (
              <img
                width="100%"
                src={s3baseUrl + exercise?.exercise_info?.image?.thumbnail_1}
              />
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
